var map = {
	"./data": 15,
	"./data.js": 15,
	"./img/product-1.png": 45,
	"./img/product-2.png": 46,
	"./img/product-3.png": 47,
	"./img/product-4.png": 48,
	"./img/product-5.png": 49,
	"./img/product-6.png": 50,
	"./img/product-7.png": 51,
	"./img/product-8.png": 52,
	"./logo.svg": 21
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;